import {
  ESRI_IMAGERY,
  OSM_STANDARD,
  vworldBase,
  vworldSatellite,
  type TileSource,
} from "@safers/model/tiles";

export { ESRI_IMAGERY, OSM_STANDARD, type TileSource };

const VWORLD_KEY = (import.meta.env.VITE_VWORLD_KEY ?? "").trim();

export const VWORLD_SATELLITE = vworldSatellite(VWORLD_KEY);
export const VWORLD_BASE = vworldBase(VWORLD_KEY);

export function imagerySource(): TileSource {
  return VWORLD_KEY ? VWORLD_SATELLITE : ESRI_IMAGERY;
}

export function basemapSource(): TileSource {
  return VWORLD_KEY ? VWORLD_BASE : OSM_STANDARD;
}
